// extracted by mini-css-extract-plugin
export default {"homepage":"ObTR1Cdsp31Oz6l6oEva","gradient":"P9clT4ruBsIOTUXgHdwq","text":"MfgkSH_XueruBjMueoQE"};